import { CreatePlanRequest, GetAllPlanReq, PlanDto, UpdatePlanRequest } from "../../interfaces";
import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { apiDelete, apiGet, apiPost, apiPut } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";


export async function getAllPlanAsync(
    authToken: string,
    payload : GetAllPlanReq,
    signal?: AbortSignal
): Promise<ApiResponse<PagedResults<PlanDto>>> {
    const queryString = buildQuery(payload);
    const apiUrl: string = `/plan?${queryString}`;

    var res = apiGet<ApiResponse<PagedResults<PlanDto>>>(
        apiUrl, authToken, signal
    );
    return res;
}

export async function CreatePlanAsync(
    authToken: string,
    payload : CreatePlanRequest,
    signal?: AbortSignal
): Promise<ApiResponse<PagedResults<PlanDto>>> {
    const apiUrl: string = `/plan`;

    var res = apiPost<ApiResponse<PagedResults<PlanDto>>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function DeletePlanAsync(
    authToken: string,
    planId : string,
    signal?: AbortSignal
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/plan/${planId}`;

    var res = apiDelete<ApiResponse<boolean>>(
        apiUrl, undefined, authToken, signal
    );
    return res;
}

export async function UpdatePlanAsync(
    authToken: string,
    planId : string,
    payload : UpdatePlanRequest,
    signal?: AbortSignal
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/plan/${planId}`;

    var res = apiPut<ApiResponse<boolean>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}